import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

const state = {};

const getters = {};

const actions = {

    createBarcode: async (context, settings) => {


        let url = "barcode/create";


        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {

                code: settings.code,
                data: settings.test,
                width: 3,
                height: 10,

            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {


                return res.data.image
                //resolve(res);
            })
            .catch(err => {

                //console.log("errore", err.response.data.error);
                return {error: err.response.data.error}
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },

    createBadge: async (context, settings) => {

        let url = "barcode/create-badge";

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, {
                _id: settings._id,
                name: settings.name,
            }, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(res => {
            return res.data.image
        })
            .catch(err => {
                return {error: err.response.data.error}
            });

    },


    createBarcodeOrder: async (context, data) => {

        let url = "barcode/create-barcode-order";

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, {
                _id: data._id,
                name: data.OrderID,
            }, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(res => {
            return res.data.image
        })
            .catch(err => {
                return {error: err.response.data.error}
            });

    },

    destroyData: (context) => {


    },


};

const mutations = {};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
